import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchGeneralSettingsAPI() {
    const response = await fetch(`${baseURL}/api/version2/init/general-settings`);
    if(!response.ok) throw new error("Failed to retch general settings data");
    return response.json()
}